<mat-dialog-content>
  <h2 mat-dialog-title>{{ data.title | translate }}</h2>
  <forms-va-input-tags
    [formControl]="formControl"
    [placeholder]="data.placeholder | translate"
    [allowDuplicates]="false"
    [options]="options$ | async"
  ></forms-va-input-tags>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="close(false)">
    {{ 'FRONTEND.LOOP.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="close(true)">
    {{ 'FRONTEND.LOOP.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
